module.exports = __webpack_public_path__ + "static/media/Z4.e6a18f11.jpg";